import styled from 'styled-components';

export const Content = styled.div`
  position: relative;
  color: var(--cp-text, #fff);
`;

export const Buttons = styled.div`
  margin: 30px 0 0;
`;
